import { Loader } from '@grafikr/components';

import { show as showOverlay } from 'utils/overlay';

export default Loader(({ node }, load) => {
  const { loadTarget } = node.dataset;

  if (!loadTarget) {
    return;
  }

  const targets = loadTarget.split(',');

  targets.forEach((target) => {
    const trimmed = target.trim();
    document.addEventListener(
      'click',
      (event) => {
        const trigger = (event.target as HTMLElement).closest<HTMLElement>('[data-load]');

        if (!trigger) return;

        const triggerTargets = trigger.dataset.load?.split(',').map((t) => t.trim()) ?? [];

        if (!triggerTargets.includes(trimmed)) {
          return;
        }

        if (trimmed === 'region-switch') {
          const headerDrawer = trigger.closest<HTMLElement>('[data-load-target="header-drawer"]');
          if (headerDrawer && !headerDrawer.hidden) {
            headerDrawer.querySelector<HTMLButtonElement>('[data-close]')?.click();
            showOverlay();
          }
        }

        if (trimmed === 'shop-the-look-dialog' && trigger.dataset.modalId) {
          node.dataset.pendingModalId = trigger.dataset.modalId;
        }

        if (trimmed === 'back-in-stock-drawer' && trigger.dataset.variantId) {
          node.dataset.pendingVariantId = trigger.dataset.variantId;

          if (trigger.dataset.productId) {
            node.dataset.pendingProductId = trigger.dataset.productId;
          }

          if (trigger.dataset.comingSoon === 'true') {
            node.dataset.pendingComingSoon = 'true';
          } else {
            delete node.dataset.pendingComingSoon;
          }

          if (trigger.dataset.backInStockTitle) {
            node.dataset.pendingBackInStockTitle = trigger.dataset.backInStockTitle;
            node.dataset.pendingBackInStockImage = trigger.dataset.backInStockImage ?? '';
            node.dataset.pendingBackInStockOptions = trigger.dataset.backInStockOptions ?? '';
          }
        }

        load();
      },
      { passive: true },
    );
  });
});
